// utils/company-storage.ts

import { BootstrapProgress } from 'src/api/queries/getAppBootstrap';

export type Company = {
  id: string;
  companyName: string;
  // Tier-1 promotion progress, surfaced on the company selector to show
  // per-workspace readiness. Optional: the persisted single company may
  // predate it, and the network bootstrap repopulates it on load.
  bootstrapProgress?: BootstrapProgress | null;
};

const STORAGE_KEY = 'selectedCompany';

/**
 * Get the currently selected company from localStorage
 */
export function getSelectedCompany(): Company | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return null;

    const company = JSON.parse(stored);
    if (!company.id || !company.companyName) return null;

    return company;
  } catch (error) {
    console.warn('Error reading selected company from localStorage:', error);
    clearSelectedCompany();
    return null;
  }
}

/**
 * Set the selected company in localStorage
 */
export function setSelectedCompany(company: Company): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(company));
  } catch (error) {
    console.error('Error saving selected company to localStorage:', error);
  }
}

/**
 * Clear the selected company from localStorage
 */
export function clearSelectedCompany(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.error('Error clearing selected company from localStorage:', error);
  }
}

/**
 * Get the selected company ID (convenience function)
 */
export function getSelectedCompanyId(): string | null {
  const company = getSelectedCompany();
  return company?.id || null;
}
